let BASEURL;

const hostname = window && window.location && window.location.hostname;

if(hostname === 'localhost') {
    // BASEURL = 'https://106.14.192.98/lb-integrated-api/mb';
    // BASEURL = 'http://192.168.0.110:8082/lb-integrated-api/mb';
    // BASEURL = 'http://192.168.0.122:8082/lb-integrated-api/mb';
    // BASEURL = 'https://office.mylunchbox.app/lb-integrated-api/mb';
    // BASEURL = 'http://192.168.0.101:8082/lb-mobile-api';
    BASEURL = 'https://47.100.41.121/lb-integrated-api/mb';
}else if(hostname === '106.14.192.98'){
    BASEURL = 'https://106.14.192.98/lb-integrated-api/mb';
}else if(hostname === '47.100.41.121'){
    BASEURL = 'https://47.100.41.121/lb-integrated-api/mb';
} else {
    BASEURL = 'https://api.lunchbox.asia/lb-mobile-api';
}

export default BASEURL 